// 2026-05-26 - FormuLearning - 로그인 페이지 (SCR-LOGIN)
// 파일 위치: frontend/src/pages/LoginPage.tsx

import { useState } from 'react'
import LoginForm from '../features/auth/LoginForm'
import RegisterForm from '../features/auth/RegisterForm'

export default function LoginPage() {
  const [isRegister, setIsRegister] = useState(false)

  return (
    <div className="flex min-h-screen items-center justify-center bg-bg-base">
      <div
        className="w-full max-w-sm rounded-lg bg-bg-card p-8"
        style={{ boxShadow: 'var(--elev-2)' }}
      >
        <div className="mb-6 text-center">
          <h1 className="text-xl font-semibold text-accent-purple">FormuLearning</h1>
          <p className="mt-1 text-xs text-text-secondary">
            {isRegister ? 'Create your account' : '6-STEP Formulation Design'}
          </p>
        </div>
        {isRegister ? (
          <RegisterForm onToggle={() => setIsRegister(false)} />
        ) : (
          <LoginForm onToggle={() => setIsRegister(true)} />
        )}
      </div>
    </div>
  )
}
